import { render } from "./ListWarningBoxes.vue?vue&type=template&id=3c7181dc"
import script from "./ListWarningBoxes.vue?vue&type=script&lang=js"
export * from "./ListWarningBoxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__